const progressBar = document.querySelector('.advertorial-header__progress-inner');

function updateProgressBar() {
  const scrollTop = window.scrollY;
  const documentHeight = document.documentElement.scrollHeight;
  const windowHeight = window.innerHeight;

  const scrollableHeight = documentHeight - windowHeight;
  const progress = (scrollTop / scrollableHeight) * 100;

  progressBar.style.width = `${Math.min(progress, 100)}%`;
}

window.addEventListener('scroll', updateProgressBar);
window.addEventListener('resize', updateProgressBar);

updateProgressBar();